import { Linkedin, Instagram, Video } from "lucide-react";

const socials = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/bhatta-abhishek/", Icon: Linkedin, testId: "social-link-linkedin" },
  { name: "Topmate", url: "https://topmate.io/bhattacharjee_abhishek", Icon: Video, testId: "social-link-topmate" },
  { name: "Instagram", url: "https://www.instagram.com/i.am.bhatta/", Icon: Instagram, testId: "social-link-instagram" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-stone-200 bg-cream/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="font-heading text-lg font-bold text-stone-900">
              Abhishek B<span className="text-amber-600">.</span>
            </p>
            <p className="text-sm text-stone-500 mt-1">Writing about AI, growth marketing, and adtech.</p>
          </div>
          <div className="flex items-center gap-3" data-testid="social-links-bar">
            {socials.map(({ name, url, Icon, testId }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testId}
                aria-label={name}
                className="inline-flex items-center gap-2 rounded-full border border-stone-200 bg-white px-4 py-2 text-sm font-medium text-stone-600 transition-all hover:border-amber-400 hover:text-amber-700 hover:-translate-y-0.5"
              >
                <Icon className="h-4 w-4" />
                {name}
              </a>
            ))}
          </div>
        </div>
        <p className="mt-8 text-xs text-stone-400">© 2026 Abhishek Bhattacharjee. All rights reserved.</p>
      </div>
    </footer>
  );
}
